<div class="h100 labeling__review-container">
    <review-image-feed class="labeling__image-feed"></review-image-feed>
    <div class="labeling__review-body">
        <review-image-header></review-image-header>
        <review-image class="labeling__review-image" [privilegesOnTask]="privilegesOnTask"></review-image>
    </div>
</div>
